<template class="full-heigth">
  <div class="app-container" style="position: relative; height: 100%; padding: 15px">
    <el-dialog
      append-to-body
      v-loading="dialogSubLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogSubVisible"
      width="90%"
    >
      <el-card class="box-card">
        <el-row>
          <el-col :span="9" style="text-align: center">
            <el-image
              v-if="subImgInfo.file"
              :src="subImgInfo.file.url"
              style="height: 500px"
              fit="contain"
            >
            </el-image>
          </el-col>
          <el-col :span="15">
            <el-form label-width="80px" v-if="subImgInfo.info">
              <el-form-item label="檔案名稱">
                {{ subImgInfo.info.fileInfo.fileRealName }}
              </el-form-item>

              <el-form-item label="上傳者">
                {{ subImgInfo.info.userInfo.name }}
              </el-form-item>

              <el-form-item label="上傳時間">
                {{ subImgInfo.info.fileInfo.buildDate }}
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <span slot="footer" class="dialog-footer action-buttons">
        <el-button
          type="success"
          @click="downloadFile(subImgInfo.file.id, subImgInfo.file.fileName)"
          >下 載</el-button
        >
        <el-popconfirm
          title="確定要刪除這張照片嗎？"
          cancel-button-text="取消"
          confirm-button-text="確定"
          @confirm="handleDeleteImage(subImgInfo.file.id)"
        >
          <el-button slot="reference" type="danger">刪 除</el-button>
        </el-popconfirm>
        <el-button @click="dialogSubVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      @open="resetAlbumSelection"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div style="color: red; font-size: 12px; margin-bottom: 10px">
        提示：第一次下載需要比較長時間處理，請耐心等候。
      </div>
      <el-card class="box-card">
        <el-row style="margin-bottom: 10px">
          <el-form :inline="true" class="imageUpload">
            <el-form-item label="圖片下載/刪除">
              <el-checkbox-group v-model="downloadType" @change="handleSelectList">
                <el-checkbox label="agency">旅行社全部</el-checkbox>
                <el-checkbox label="leader">領隊全部</el-checkbox>
                <el-checkbox label="travelers">旅客全部</el-checkbox>
                <el-checkbox label="all">全選</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item>
              <el-button v-if="!showChk" type="primary" size="mini" @click="enablePhotoSelection">
                選取照片
              </el-button>
              <el-tag style="margin-left: 10px" v-if="imageIDs.length > 0"
                >{{ `共選擇 ${imageIDs.length} 張照片` }}
              </el-tag>

              <el-button
                v-if="showChk"
                type="warning"
                size="mini"
                style="margin-top: 10px"
                @click="cancelSelect"
                >取消選取</el-button
              >
            </el-form-item>
          </el-form>
        </el-row>

        <el-tabs v-model="activeAlbumName" type="border-card">
          <el-tab-pane
            v-for="albumType in albumTypes"
            :key="albumType.name"
            :label="albumType.label"
            :name="albumType.name"
          >
            <AlbumGallery
              :albums="filteredAlbums[albumType.albumKey]"
              :group-tags="albumGroupTag"
              :selected-group-tag="selectedAlbumGroupTag"
              :selected-image-ids.sync="imageIDs"
              :show-selection="showChk"
              :show-group-tags="downloadType.length === 0 || downloadType[0] === 'cancelCheck'"
              :loading="spinLoading"
              :has-more="activeAlbumHasMore"
              :load-more-loading="albumPageLoading"
              @select-group-tag="handleSelectGroupTag"
              @delete-group-tag="handleDeleteConfirm"
              @check-image="checkImage"
              @load-more="loadMoreAlbums(albumType.name)"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <span slot="footer" class="dialog-footer action-buttons">
        <el-button @click="downloadImages" type="success" v-if="imageIDs.length > 0"
          >下 載</el-button
        >
        <el-popconfirm
          title="確定要刪除選取的照片嗎？"
          v-if="activeAlbumName == 'agency' && imageIDs.length > 0"
          cancel-button-text="取消"
          confirm-button-text="確定"
          @confirm="handleDeleteImages"
        >
          <el-button slot="reference" type="danger">刪 除</el-button>
        </el-popconfirm>

        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入團號或團名"
          @keyup.enter.native="getAgencyTravels"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getAgencyTravels"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%" v-loading="listLoading">
      <el-table size="mini" :data="list" border style="width: 100%" height="100%">
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tourGroupNo" label="團號" width="200" align="center">
        </el-table-column>
        <el-table-column align="center" label="團名" width="450">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag style="font-size: 14px">
                出發
                <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                - 回程
                <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="查看相簿" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="getAlbum(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="上傳圖片" width="100">
          <template slot-scope="scope">
            <div @click="getPhotoToPublicAlbumGroupTag(scope.row.id, true)">
              <MultipleImage
                :title="`上傳圖片（團號：${scope.row.tourGroupNo}）`"
                :travelId="scope.row.id"
                :groupNo="scope.row.tourGroupNo"
                :albumGroupTag="albumGroupTag"
                @getGroupTagList="getPhotoToPublicAlbumGroupTag(scope.row.id, true)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getAgencyTravels"
      />
    </div>
  </div>
</template>

<script>
import { downloadAs } from '@/utils/funcs'
import Pagination from '@/components/Pagination'
import MultipleImage from '@/components/Upload/MultipleImage'
import request from '@/utils/request'
import { getAgencyTravels } from '@/api/agency'
import {
  getPublicAlbum,
  getPublicAlbumAnPhoto,
  getPhotoToPublicAlbumGroupTag,
  deletePublicAlbumAnPhoto,
  deletePhotoToPublicAlbumGroupTag,
} from '@/api/travel'
import AlbumGallery from './AlbumGallery'

const ALBUM_TYPES = [
  { name: 'agency', label: '旅行社', albumKey: 'agencyAlbum' },
  { name: 'leader', label: '領隊', albumKey: 'leaderAlbum' },
  { name: 'travelers', label: '旅客', albumKey: 'travelerAlbum' },
]
const ALBUM_PAGE_SIZE = 20

export default {
  name: 'PublicAlbum',
  components: {
    AlbumGallery,
    Pagination,
    MultipleImage,
  },
  data() {
    return {
      albumTypes: ALBUM_TYPES,
      imageIDs: [],
      showChk: false,
      activeAlbumName: 'agency',
      travelID: null,
      funcName: '相簿',
      dialogVisible: false,
      dialogLoading: false,
      dialogSubVisible: false,
      dialogSubLoading: false,
      listLoading: false,
      spinLoading: false,
      albumPageLoading: false,
      albumPagination: {
        agency: { page: 0, hasMore: true },
        leader: { page: 0, hasMore: true },
        travelers: { page: 0, hasMore: true },
      },
      albumRequestId: 0,
      apiLeaderAlbums: [],
      leaderGroupTags: [],
      dialogTopMargin: '2%',
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-buildDate',
      },
      total: 0,
      list: [],
      travelAlbums: {},
      subImgInfo: {},
      downloadType: [],
      albumGroupTag: [],
      selectedAlbumGroupTag: {
        id: null,
        name: null,
      },
    }
  },
  computed: {
    filteredAlbums() {
      return this.albumTypes.reduce((albumsByType, albumType) => {
        const albums = this.travelAlbums[albumType.albumKey] || []
        albumsByType[albumType.albumKey] = albums.map(album => {
          const files = (album.files || []).filter(
            file =>
              String(file.mapGroupTagId) === String(this.selectedAlbumGroupTag.id) ||
              file.mapGroupTagName === this.selectedAlbumGroupTag.name ||
              (this.selectedAlbumGroupTag.id === 0 && !file.mapGroupTagId)
          )
          return Object.assign({}, album, { files })
        })
        return albumsByType
      }, {})
    },
    activeAlbumHasMore() {
      return this.albumPagination[this.activeAlbumName].hasMore
    },
  },
  watch: {
    activeAlbumName(newName, oldName) {
      if (newName !== oldName && newName) {
        this.getPhotoToPublicAlbumGroupTag(this.travelID)
      }
    },
  },
  async created() {
    await this.getAgencyTravels()
  },
  methods: {
    resetAlbumSelection() {
      this.imageIDs = []
    },
    enablePhotoSelection() {
      this.downloadType = []
      this.imageIDs = []
      this.showChk = true
    },
    handleSelectList() {
      if (this.downloadType.length > 1) {
        this.downloadType.splice(0, 1)
      }
      this.handleCheckAllChange()
    },
    async downloadImages() {
      if (this.imageIDs.length === 0) {
        alert('未選擇照片。')
        return
      }

      this.dialogLoading = true
      let blobUrl
      try {
        await this.$store.dispatch(
          'app/showDownloadLoadingText',
          '照片正在打包下載中，請不要離開此畫面，感謝您的耐心等候。'
        )
        await this.$store.dispatch('app/showDownloadLoading', true)
        const response = await request({
          url: '/TravelSettings/downloadImages',
          method: 'post',
          data: { ids: this.imageIDs.slice() },
          headers: { 'Content-Type': 'application/json' },
        })
        const fileResponse = await fetch(response.data.downLoadUrl)
        if (!fileResponse.ok) {
          throw new Error(`下載相簿失敗：${fileResponse.status}`)
        }

        blobUrl = window.URL.createObjectURL(await fileResponse.blob())
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = '相簿.zip'
        link.click()

        this.$notify({
          title: '成功',
          message: '相簿批次下載處理完成',
          type: 'success',
        })
      } catch (error) {
        console.error(error)
        this.$notify({
          title: '下載失敗',
          message: '相簿下載失敗，請稍後再試。',
          type: 'error',
        })
      } finally {
        if (blobUrl) {
          window.URL.revokeObjectURL(blobUrl)
        }
        this.dialogLoading = false
        await this.$store.dispatch('app/showDownloadLoading', false)
        await this.$store.dispatch('app/showDownloadLoadingText', '')
      }
    },
    async handleDeleteImages() {
      if (this.imageIDs.length === 0) {
        alert('未選擇照片。')
        return
      }

      this.dialogLoading = true
      try {
        await deletePublicAlbumAnPhoto({
          travelID: this.travelID,
          ids: this.imageIDs.slice(),
        })
        this.$notify({
          title: '成功',
          message: '相簿批次刪除處理完成',
          type: 'success',
        })
        this.imageIDs = []
        this.downloadType = []
        this.showChk = false
        await this.getAlbum(this.travelID)
      } catch (error) {
        console.error(error)
      } finally {
        this.dialogLoading = false
      }
    },
    async handleDeleteImage(id) {
      if (!id) return

      this.dialogLoading = true
      try {
        await deletePublicAlbumAnPhoto({
          travelID: this.travelID,
          ids: [id],
        })
        this.$notify({
          title: '成功',
          message: '相簿刪除處理完成',
          type: 'success',
        })
        await this.getAlbum(this.travelID)
        this.dialogSubVisible = false
      } catch (error) {
        console.error(error)
      } finally {
        this.dialogLoading = false
      }
    },
    handleCheckAllChange() {
      this.showChk = this.downloadType.length > 0
      this.imageIDs = []

      const selectedType = this.downloadType[0]
      if (!this.showChk || selectedType === 'cancelCheck') {
        this.showChk = false
        return
      }

      const albumTypes =
        selectedType === 'all'
          ? this.albumTypes
          : this.albumTypes.filter(albumType => albumType.name === selectedType)
      if (selectedType !== 'all') {
        this.activeAlbumName = selectedType
      }

      albumTypes.forEach(albumType => {
        const albums = this.travelAlbums[albumType.albumKey] || []
        albums.forEach(album => {
          ;(album.files || []).forEach(file => {
            if (!this.imageIDs.includes(file.id)) {
              this.imageIDs.push(file.id)
            }
          })
        })
      })
    },
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-buildDate',
      }
      await this.getAgencyTravels()
    },
    async getAgencyTravels() {
      this.listLoading = true
      try {
        const response = await getAgencyTravels(this.listQuery)
        this.list = response.data.data
        this.total = response.data.total
      } finally {
        this.listLoading = false
      }
    },
    async getAlbum(travelID) {
      this.albumRequestId += 1
      const requestId = this.albumRequestId
      this.albumPageLoading = false
      this.travelID = travelID
      this.travelAlbums = {
        agencyAlbum: [],
        leaderAlbum: [],
        travelerAlbum: [],
      }
      this.apiLeaderAlbums = []
      this.leaderGroupTags = []
      this.albumPagination = {
        agency: { page: 0, hasMore: true },
        leader: { page: 0, hasMore: true },
        travelers: { page: 0, hasMore: true },
      }
      this.imageIDs = []
      this.showChk = false
      this.downloadType = []
      this.dialogVisible = true
      try {
        await this.loadMoreAlbums(this.activeAlbumName, true)
        if (requestId !== this.albumRequestId) return
        await this.getPhotoToPublicAlbumGroupTag(travelID)
      } catch (error) {
        console.error(error)
        this.$message.error(error.message || '載入相簿失敗')
      }
    },
    async loadMoreAlbums(albumName = this.activeAlbumName, loadInitialPage = false) {
      const albumType = this.albumTypes.find(type => type.name === albumName)
      if (!albumType || !this.travelID) return

      const pagination = this.albumPagination[albumName]
      if (this.albumPageLoading || (!loadInitialPage && !pagination.hasMore)) return

      const requestId = this.albumRequestId
      const travelID = this.travelID
      this.albumPageLoading = true
      try {
        const existingPhotoIds = new Set()
        this.albumTypes.forEach(albumType => {
          const albums = this.travelAlbums[albumType.albumKey] || []
          albums.forEach(album => {
            const files = album.files || []
            files.forEach(file => existingPhotoIds.add(file.id))
          })
        })

        const page = pagination.page + 1
        const response = await getPublicAlbum({
          travelID,
          page,
          limit: ALBUM_PAGE_SIZE,
        })
        if (requestId !== this.albumRequestId) return
        if (!response || !response.success || !response.data) {
          this.$message.error((response && response.message) || '載入相簿失敗')
          return
        }

        const responseAlbumTypes = loadInitialPage ? this.albumTypes : [albumType]
        responseAlbumTypes.forEach(responseAlbumType => {
          const pageAlbums = response.data[responseAlbumType.albumKey]
          if (!Array.isArray(pageAlbums)) {
            this.albumPagination[responseAlbumType.name].hasMore = false
            return
          }

          const loadedPhotoCount = this.countPhotosInGroup(pageAlbums, this.selectedAlbumGroupTag)
          pageAlbums.forEach(album => {
            if (responseAlbumType.name === 'leader') {
              this.apiLeaderAlbums.push(album)
            } else {
              this.travelAlbums[responseAlbumType.albumKey].push(album)
            }
          })

          this.albumPagination[responseAlbumType.name] = {
            page,
            hasMore: loadedPhotoCount >= ALBUM_PAGE_SIZE,
          }
        })

        this.updateLeaderAlbums()
        this.addLoadedPhotosToSelection(existingPhotoIds)
      } catch (error) {
        if (requestId !== this.albumRequestId) return
        this.$message.error(error.message || '載入相簿失敗')
      } finally {
        if (requestId === this.albumRequestId) {
          this.albumPageLoading = false
        }
      }
    },
    updateLeaderAlbums() {
      const hasLeaderPhotos = this.apiLeaderAlbums.some(
        album => Array.isArray(album.files) && album.files.length > 0
      )
      if (hasLeaderPhotos || this.leaderGroupTags.length === 0) {
        this.travelAlbums.leaderAlbum = this.apiLeaderAlbums.slice()
        return
      }

      this.travelAlbums.leaderAlbum = this.leaderGroupTags.reduce((albums, groupTag) => {
        if (!groupTag.groupTagId || groupTag.groupTagId <= 0) return albums

        const files = []
        const sourceAlbumKeys = ['agencyAlbum', 'travelerAlbum']
        sourceAlbumKeys.forEach(albumKey => {
          const sourceAlbums = this.travelAlbums[albumKey] || []
          sourceAlbums.forEach(album => {
            const sourceFiles = album.files || []
            sourceFiles.forEach(file => {
              if (String(file.mapGroupTagId) === String(groupTag.groupTagId)) {
                files.push(file)
              }
            })
          })
        })

        if (files.length > 0) {
          albums.push({ type: 0, files })
        }
        return albums
      }, [])
    },
    countPhotosInGroup(albums, groupTag) {
      if (!groupTag || groupTag.id === null || groupTag.id === undefined) return 0

      return albums.reduce((count, album) => {
        const files = album.files || []
        return (
          count +
          files.filter(
            file =>
              String(file.mapGroupTagId) === String(groupTag.id) ||
              file.mapGroupTagName === groupTag.name ||
              (groupTag.id === 0 && !file.mapGroupTagId)
          ).length
        )
      }, 0)
    },
    updateActiveAlbumHasMore() {
      const albumType = this.albumTypes.find(type => type.name === this.activeAlbumName)
      if (!albumType) return

      const albums = this.travelAlbums[albumType.albumKey] || []
      this.albumPagination[this.activeAlbumName].hasMore =
        this.countPhotosInGroup(albums, this.selectedAlbumGroupTag) >= ALBUM_PAGE_SIZE
    },
    addLoadedPhotosToSelection(existingPhotoIds) {
      if (!this.showChk) return

      const selectedType = this.downloadType[0]
      const selectedAlbumTypes =
        selectedType === 'all'
          ? this.albumTypes
          : selectedType
            ? this.albumTypes.filter(albumType => albumType.name === selectedType)
            : this.albumTypes.filter(albumType => albumType.name === this.activeAlbumName)

      selectedAlbumTypes.forEach(albumType => {
        const albums = this.travelAlbums[albumType.albumKey] || []
        albums.forEach(album => {
          const files = album.files || []
          files.forEach(file => {
            if (existingPhotoIds.has(file.id)) return

            const matchesSelectedGroup =
              selectedType !== undefined && selectedType !== 'all'
                ? true
                : String(file.mapGroupTagId) === String(this.selectedAlbumGroupTag.id) ||
                  file.mapGroupTagName === this.selectedAlbumGroupTag.name ||
                  (this.selectedAlbumGroupTag.id === 0 && !file.mapGroupTagId)
            if (matchesSelectedGroup && !this.imageIDs.includes(file.id)) {
              this.imageIDs.push(file.id)
            }
          })
        })
      })
    },
    async checkImage(id) {
      this.dialogSubVisible = true
      this.dialogSubLoading = true
      try {
        const response = await getPublicAlbumAnPhoto({
          travelID: this.travelID,
          fileID: id,
        })
        this.subImgInfo = response.data
      } finally {
        this.dialogSubLoading = false
      }
    },
    async downloadFile(id, fileName) {
      this.dialogSubLoading = true
      await this.$store.dispatch('app/showDownloadLoading', true)
      try {
        await downloadAs(id, fileName)
        this.$notify({
          title: '成功',
          message: '相簿下載處理完成',
          type: 'success',
        })
      } catch (error) {
        console.error(error)
        this.$notify({
          title: '下載失敗',
          message: '相簿下載失敗，請稍後再試。',
          type: 'error',
        })
      } finally {
        this.dialogSubLoading = false
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
    async getPhotoToPublicAlbumGroupTag(id, isUpdate = false) {
      if (!id) return

      const requestId = this.albumRequestId
      this.spinLoading = true
      try {
        const response = await getPhotoToPublicAlbumGroupTag({ travelID: id })
        if (requestId !== this.albumRequestId) return
        const allAlbumGroupTags = response.success
          ? response.data.reduce((tags, item) => {
              const key = Object.keys(item)[0]
              tags[key] = item[key]
              return tags
            }, {})
          : {}
        this.leaderGroupTags = allAlbumGroupTags.leaderGroupTag || []
        this.updateLeaderAlbums()

        const groupTags = isUpdate
          ? allAlbumGroupTags.agencyGroupTag
          : allAlbumGroupTags[`${this.activeAlbumName}GroupTag`]
        this.albumGroupTag = groupTags || []
        const selectedGroupTag = this.albumGroupTag[0]
        this.selectedAlbumGroupTag = selectedGroupTag
          ? { id: selectedGroupTag.groupTagId, name: selectedGroupTag.groupTagName }
          : { id: null, name: null }
        this.updateActiveAlbumHasMore()
      } finally {
        if (requestId === this.albumRequestId) {
          this.spinLoading = false
        }
      }
    },
    async handleDeleteConfirm(groupTagId) {
      if (!groupTagId) {
        const albumType = this.albumTypes.find(item => item.name === this.activeAlbumName)
        const albums = albumType ? this.filteredAlbums[albumType.albumKey] || [] : []
        const ids = albums.reduce((fileIDs, album) => {
          return fileIDs.concat((album.files || []).map(file => file.id))
        }, [])

        if (ids.length === 0) {
          this.$notify({
            title: '提示',
            message: '當前相簿沒有照片',
            type: 'warning',
          })
          return
        }

        const response = await deletePublicAlbumAnPhoto({
          travelID: this.travelID,
          ids,
        })
        if (response.success) {
          await this.getAlbum(this.travelID)
        }
        return
      }

      const response = await deletePhotoToPublicAlbumGroupTag({
        travelID: this.travelID,
        groupTagId,
      })
      if (response.success) {
        if (this.selectedAlbumGroupTag.id === groupTagId) {
          this.selectedAlbumGroupTag = { id: null, name: null }
        }
        this.albumGroupTag = this.albumGroupTag.filter(item => item.groupTagId !== groupTagId)
      }
    },
    handleSelectGroupTag(groupTag) {
      this.showChk = false
      this.imageIDs = []
      this.selectedAlbumGroupTag = {
        id: groupTag.groupTagId,
        name: groupTag.groupTagName,
      }
      this.updateActiveAlbumHasMore()
      this.downloadType = []

      const albumType = this.albumTypes.find(item => item.name === this.activeAlbumName)
      const albums = albumType ? this.travelAlbums[albumType.albumKey] || [] : []
      this.imageIDs = albums.reduce((fileIDs, album) => {
        const files = album.files || []
        files.forEach(file => {
          if (
            String(file.mapGroupTagId) === String(groupTag.groupTagId) ||
            file.mapGroupTagName === groupTag.groupTagName
          ) {
            fileIDs.push(file.id)
          }
        })
        return fileIDs
      }, [])
      this.showChk = true
    },
    cancelSelect() {
      this.downloadType = ['cancelCheck']
      this.handleSelectList()
    },
  },
}
</script>

<style>
.el-dialog__body {
  padding: 15px !important;
}
</style>

<style scoped>
.el-tab-pane {
  height: auto !important;
}

.imageUpload .el-form-item {
  margin-bottom: 0 !important;
}

.full-heigth {
  position: relative;
  height: 100%;
}

.el-icon-circle-close {
  color: wheat !important;
}

.action-buttons {
  display: flex;
  gap: 0 8px;
  justify-content: flex-end;
}
</style>
